import React, { Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import useStyles from "./activate.styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Hidden from "@material-ui/core/Hidden";
const androidHref = "https://play.google.com/store/apps/details?id=com.unicity.activate";
const iosHref = "https://apps.apple.com/us/app/unicity-activate/id1462867388";
// https://apps.apple.com/us/app/unicity-activate/id1462867388
//itms-apps://itunes.apple.com/us/app/apple-store/id1462867388?mt=8
const Activate = ({ isAndroid, isIOS }) => {
    const classes = useStyles();

    const redirect = () => {
        const href = isAndroid ? androidHref : iosHref;
        window.location.href = href;
        return null;
    };
    return isAndroid || isIOS ? (
        redirect()
    ) : (
        <Fragment>
            <Paper className={classes.paper}>
                <Grid className={classes.row} container spacing={5}>
                    <Grid item xs={4} sm={3} md={3}>
                        <div className={classes.logoWrapper}>
                            <img className={classes.logo} src="/img/activate.jpg" alt="Activate App Logo" />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <Hidden xsDown>
                            <Typography variant="h4" component="h1">
                                Available on the App Store and Google Play!
                            </Typography>
                        </Hidden>
                        <Hidden smUp>
                            <Typography variant="h5" component="h1">
                                Available on the App Store and Google Play!
                            </Typography>
                        </Hidden>
                    </Grid>
                </Grid>
                <Grid className={classes.logoRow} container>
                    <Grid item xs={7} sm={5} md={3}>
                        <a href={iosHref}>
                            <img
                                alt="iOS Logo, App available in the App Store"
                                className={classes.storeLogos}
                                src="/img/ios_logo.jpg"
                            />
                        </a>
                    </Grid>
                </Grid>
                <Grid className={classes.logoRow} container>
                    <Grid item xs={7} sm={5} md={3}>
                        <a href={androidHref}>
                            <img
                                alt="Android Logo, App available on Google Play"
                                className={classes.storeLogos}
                                src="/img/android_logo.jpg"
                            />
                        </a>
                    </Grid>
                </Grid>
            </Paper>
        </Fragment>
    );
};
export default Activate;
